module.exports = __webpack_public_path__ + "static/gallery30-63379c47402bb198024ca1c6e2a2fbcb.png";